module.exports = __webpack_public_path__ + "static/PATENSCHAFT_1-4a12fc6437013c37d127e7e994f485e2.jpg";